import { Factory } from '../../../lib/api';
const getAreaList = () => Factory.get('api/v2/areas/list');
export default getAreaList;
